// ══════════════════════════════════════════════════════════════════════════════════════════════
//  EL PREFIJO Y LA LONGITUD DEL TELÉFONO DE CADA PAÍS — ESPEJO DEL BACKEND  ·  B-613
// ══════════════════════════════════════════════════════════════════════════════════════════════
//
//  ESTO ES EL ESPEJO de `backend/services/prefijosTelefono.js` y de las funciones nuevas de
//  `backend/services/telefonoE164.js` (`aE164Declarado`, `motivoDeclarado`, `avisoDeclarado`,
//  `sugerenciaDeclarada`, `PATRON_ES_COMPLETO`). SI TOCAS UNA, TOCA LA OTRA: hay una guardia que
//  EJECUTA LAS DOS A LA VEZ, país por país y número por número
//  (`backend/services/telefono-las-dos-mitades-del-pais.test.js`). Es el mismo trato que
//  `utils/telefono.js` tiene con `services/movilPaciente.js`.
//
//  POR QUÉ UNA COPIA Y NO UN ENDPOINT. Hace falta en pantallas PÚBLICAS —el pre-registro que rellena
//  el paciente, el formulario de derivación, el portal del profesional— antes de cualquier login, y
//  hace falta EN CADA TECLA para poder avisar en el momento. Son ~76 filas y un par de kilobytes.
//  Un endpoint sería una llamada de red por pantalla para leer una tabla que no cambia nunca.
//
//  LOS NOMBRES salen de `./paises`, que ya es el espejo de `verifactu-core/paises` y es la lista con
//  la que la clínica elige el país del documento de un paciente.
//
//  LA BANDERA se calcula del propio código ISO (dos letras → dos indicadores regionales): ni
//  imágenes ni una lista que se quede vieja. Es la ÚNICA excepción de emoji de la casa, y es la que
//  pidió el dueño con esas palabras: «algo tipo banderita y nombre de pais».
//
//  `paisDelNumero` SE CONSUME SIEMPRE MIRANDO `.ambiguo`: la función devuelve un objeto con país
//  incluso cuando NO se sabe cuál es (Estados Unidos, Canadá y República Dominicana comparten el
//  prefijo «1»). Proponer «Estados Unidos» para un número dominicano es proponer un país falso, y
//  de ahí sale un envío al país equivocado. Sin `.ambiguo === false`, no se propone nada.
import { PAISES } from './paises'

// pais ISO-2 → [prefijo, [longitudes nacionales], troncal]
export const TABLA = {
  ES: ['34', [9], ''],
  PT: ['351', [9], ''],
  FR: ['33', [9], '0'],
  IT: ['39', [9, 10], ''],
  DE: ['49', [10, 11], '0'],
  GB: ['44', [10], '0'],
  IE: ['353', [7, 8, 9], '0'],
  NL: ['31', [9], '0'],
  BE: ['32', [8, 9], '0'],
  LU: ['352', [9], ''],
  CH: ['41', [9], '0'],
  AT: ['43', [10, 11], '0'],
  DK: ['45', [8], ''],
  SE: ['46', [9], '0'],
  NO: ['47', [8], ''],
  FI: ['358', [9], '0'],
  IS: ['354', [7], ''],
  PL: ['48', [9], ''],
  CZ: ['420', [9], ''],
  SK: ['421', [9], '0'],
  HU: ['36', [9], '06'],
  RO: ['40', [9], '0'],
  BG: ['359', [8, 9], '0'],
  GR: ['30', [10], ''],
  HR: ['385', [8, 9], '0'],
  SI: ['386', [8], '0'],
  RS: ['381', [8, 9], '0'],
  LT: ['370', [8], '8'],
  LV: ['371', [8], ''],
  EE: ['372', [7, 8], ''],
  MT: ['356', [8], ''],
  CY: ['357', [8], ''],
  AD: ['376', [6, 9], ''],
  MC: ['377', [8, 9], ''],
  UA: ['380', [9], '0'],
  RU: ['7', [10], '8'],
  BY: ['375', [9], '8'],
  MD: ['373', [8], '0'],
  TR: ['90', [10], '0'],
  MA: ['212', [9], '0'],
  DZ: ['213', [9], '0'],
  TN: ['216', [8], ''],
  EG: ['20', [9, 10], '0'],
  SN: ['221', [9], ''],
  NG: ['234', [8, 9, 10], '0'],
  ZA: ['27', [9], '0'],
  US: ['1', [10], '1'],
  CA: ['1', [10], '1'],
  MX: ['52', [10], '01'],
  AR: ['54', [10], '0'],
  BR: ['55', [10, 11], '0'],
  CL: ['56', [9], '0'],
  CO: ['57', [10], '0'],
  PE: ['51', [9], '0'],
  VE: ['58', [10], '0'],
  EC: ['593', [9], '0'],
  BO: ['591', [8], ''],
  PY: ['595', [9], '0'],
  UY: ['598', [8], '0'],
  CU: ['53', [8], '0'],
  DO: ['1', [10], '1'],
  CR: ['506', [8], ''],
  PA: ['507', [8], ''],
  GT: ['502', [8], ''],
  HN: ['504', [8], ''],
  SV: ['503', [8], ''],
  NI: ['505', [8], ''],
  CN: ['86', [11], '0'],
  JP: ['81', [10], '0'],
  IN: ['91', [10], '0'],
  PK: ['92', [10], '0'],
  PH: ['63', [10], '0'],
  AU: ['61', [9], '0'],
  NZ: ['64', [8, 9], '0'],
  IL: ['972', [9], '0'],
  AE: ['971', [9], '0'],
  SA: ['966', [9], '0'],
}

// El país por defecto de la casa, en prefijo. Igual que `services/telefonoE164.PAIS_DEFECTO`.
export const PAIS_DEFECTO = '34'

// Un número español COMPLETO (móvil o fijo, con o sin prefijo). El árbitro de la regla de la
// ambigüedad; la copia de verdad vive en `backend/services/movilPaciente.PATRON_ES_COMPLETO`.
export const PATRON_ES_COMPLETO = '^(0034|34)?[6789][0-9]{8}$'
const RE_ES_COMPLETO = new RegExp(PATRON_ES_COMPLETO)
// Y un MÓVIL español (6 o 7), que es la otra mitad de la regla: nunca se desvía a otro país un texto
// que HOY llega a un móvil español. Espejo de `movilPaciente.PATRON`. El porqué entero, con el caso
// que lo obliga («0600112233» + Irlanda → 353600112233), está encima de `aE164Declarado` en el
// backend: el patrón de arriba NO admite un cero delante y por ahí se escapaba.
export const PATRON_ES_MOVIL = '^(0034|34)?[67][0-9]{8}$'
const RE_ES_MOVIL = new RegExp(PATRON_ES_MOVIL)

// Separadores que en la práctica significan «aquí hay DOS números». Igual que en telefonoE164.
const SEPARADORES = /[/;,]| y | o |\n/i
const PLAUSIBLE = /^[1-9]\d{7,14}$/

const iso = (p) => String(p == null ? '' : p).trim().toUpperCase()

export function paisDeTelefono(codigo) {
  const c = iso(codigo)
  const fila = TABLA[c]
  if (!fila || !PAISES[c]) return null
  return { iso: c, nombre: PAISES[c], prefijo: fila[0], longitudes: fila[1].slice(), troncal: fila[2] || '' }
}

export function banderaDe(codigo) {
  const c = iso(codigo)
  if (!/^[A-Z]{2}$/.test(c)) return ''
  return String.fromCodePoint(...[...c].map((l) => 0x1f1e6 + (l.charCodeAt(0) - 65)))
}

export function listaParaElegir() {
  const fuera = Object.keys(TABLA)
    .filter((c) => PAISES[c])
    .map((c) => ({ iso: c, nombre: PAISES[c], prefijo: TABLA[c][0], bandera: banderaDe(c) }))
    .sort((a, b) => a.nombre.localeCompare(b.nombre, 'es'))
  const i = fuera.findIndex((p) => p.iso === 'ES')
  if (i > 0) fuera.unshift(fuera.splice(i, 1)[0])
  return fuera
}

export function longitudValida(codigo, nacional) {
  const p = paisDeTelefono(codigo)
  const d = String(nacional == null ? '' : nacional).replace(/\D/g, '')
  if (!p || !d) return false
  return p.longitudes.includes(d.length)
}

export function sinTroncal(codigo, nacional) {
  const p = paisDeTelefono(codigo)
  const d = String(nacional == null ? '' : nacional).replace(/\D/g, '')
  if (!p || !p.troncal) return d
  if (d.startsWith(p.troncal) && p.longitudes.includes(d.length - p.troncal.length)) return d.slice(p.troncal.length)
  return d
}

export function paisDelNumero(e164) {
  const d = String(e164 == null ? '' : e164).replace(/\D/g, '')
  if (!d) return null
  let mejor = null
  for (const c of Object.keys(TABLA)) {
    const [pref, longs] = TABLA[c]
    if (!d.startsWith(pref)) continue
    if (!longs.includes(d.length - pref.length)) continue
    if (!mejor || pref.length > mejor.prefijo.length) mejor = paisDeTelefono(c)
    else if (pref.length === mejor.prefijo.length && mejor.iso !== c) mejor = { ...mejor, ambiguo: true }
  }
  return mejor && !mejor.ambiguo ? mejor : (mejor ? { ...mejor } : null)
}

// ── LA COMPOSICIÓN: ESPEJO DE services/telefonoE164 ───────────────────────────────────────────

export function _limpiar(valor) {
  let s = String(valor == null ? '' : valor).trim()
  if (!s) return { d: '', masDelante: false }
  s = s.split(SEPARADORES)[0]
  s = s.replace(/\(([^)]*)\)/g, (todo, dentro) => (/\d/.test(dentro) ? dentro : ' '))
  return { d: s.replace(/\D/g, ''), masDelante: /^\s*\+/.test(s) }
}

function conPaisDelPaciente(d, paisIso) {
  const pais = paisDeTelefono(paisIso)
  if (!pais || pais.prefijo === PAIS_DEFECTO) return null
  if (d.startsWith(pais.prefijo) && pais.longitudes.includes(d.length - pais.prefijo.length)) return d
  const nacional = sinTroncal(pais.iso, d)
  if (!longitudValida(pais.iso, nacional)) return null
  return pais.prefijo + nacional
}

/** El número para WhatsApp cuando NO hay país elegido. Espejo de `telefonoE164.aE164`. */
export function aE164(valor, paisDefecto = PAIS_DEFECTO, paisIso = null) {
  const l = _limpiar(valor)
  const masDelante = l.masDelante
  let d = l.d
  if (!d) return null
  if (d.startsWith('00')) return PLAUSIBLE.test(d.slice(2)) ? d.slice(2) : null
  if (masDelante) return PLAUSIBLE.test(d) ? d : null
  // Con la excepción de la regla de la ambigüedad: si ese texto HOY llega a un móvil español, no se
  // toca (ver el backend). Un fijo español sí puede componerse con el país de la ficha.
  if (paisIso && /^0/.test(d) && !desviaUnMovilEspanol(valor)) {
    const conPais = conPaisDelPaciente(d, paisIso)
    if (conPais) return conPais
  }
  while (d.startsWith('0')) d = d.slice(1)
  if (/^[6789]\d{8}$/.test(d)) return paisDefecto + d
  const nac = d.startsWith(paisDefecto) ? d.slice(paisDefecto.length) : null
  if (nac && /^[6789]\d{8}$/.test(nac)) return d
  if (PLAUSIBLE.test(d) && !d.startsWith(paisDefecto) && d.length >= 11) return d
  if (paisIso) {
    const conPais = conPaisDelPaciente(d, paisIso)
    if (conPais) return conPais
  }
  return null
}

/**
 * El número para WhatsApp cuando alguien ELIGIÓ el país de ESE campo. `null` si no se puede componer
 * sin adivinar — que incluye, A PROPÓSITO, el caso en que el texto también se lee como un número
 * español completo (LA REGLA DE LA AMBIGÜEDAD). El porqué entero está en el backend.
 */
export function aE164Declarado(valor, paisIso, paisDefecto = PAIS_DEFECTO) {
  const { d, masDelante } = _limpiar(valor)
  if (!d) return null
  if (masDelante || d.startsWith('00')) return aE164(valor, paisDefecto, paisIso)
  const pais = paisDeTelefono(paisIso)
  if (!pais || pais.prefijo === paisDefecto) return aE164(valor, paisDefecto, paisIso)
  if (RE_ES_COMPLETO.test(d)) return null
  if (desviaUnMovilEspanol(valor)) return null
  return conPaisDelPaciente(d, pais.iso)
}

/**
 * ¿COMPONER ESTE TEXTO CON OTRO PAÍS LE QUITARÍA EL WHATSAPP A QUIEN HOY LO RECIBE? Espejo de
 * `backend/services/telefonoE164.desviaUnMovilEspanol`. Se pregunta a `aE164` —la misma función que
 * manda— para que no haya dos lecturas del mismo campo.
 */
export function desviaUnMovilEspanol(valor) {
  const e = aE164(valor)
  return !!e && RE_ES_MOVIL.test(e)
}

/** Espejo de `telefonoE164.motivoNoValido`: el porqué cuando NO hay país elegido. */
export function motivoNoValido(valor, paisDefecto = PAIS_DEFECTO, paisIso = null) {
  const s = String(valor == null ? '' : valor).trim()
  if (!s) return 'no tiene teléfono'
  if (aE164(s, paisDefecto, paisIso)) return null
  const d = s.replace(/\D/g, '')
  if (!d) return 'el teléfono no tiene ningún número'
  if (SEPARADORES.test(s)) return 'el campo del teléfono lleva más de un número'
  if (d.length < 8) return 'el teléfono está incompleto'
  if (d.length > 15) return 'el teléfono tiene demasiados dígitos'
  if (paisIso) {
    const pais = paisDeTelefono(paisIso)
    if (pais) {
      const cifras = pais.longitudes.join(' o ')
      return `el teléfono no encaja con un número de ${pais.nombre} (${cifras} cifras) ni con uno español`
    }
  }
  return 'el teléfono no tiene un formato válido'
}

function cifrasDe(longitudes) {
  const l = (longitudes || []).slice()
  if (l.length <= 1) return String(l[0] == null ? '' : l[0])
  return l.slice(0, -1).join(', ') + ' o ' + l[l.length - 1]
}

/** Cómo habría que escribirlo para que no se pueda volver a confundir. Solo AÑADE el prefijo. */
export function sugerenciaDeclarada(valor, paisIso) {
  const { d, masDelante } = _limpiar(valor)
  if (!d || masDelante || d.startsWith('00')) return null
  const pais = paisDeTelefono(paisIso)
  if (!pais || pais.prefijo === PAIS_DEFECTO) return null
  const nacional = sinTroncal(pais.iso, d)
  if (!longitudValida(pais.iso, nacional)) return null
  return '+' + pais.prefijo + ' ' + nacional
}

/**
 * ¿ESTE CAMPO ES EL CASO AMBIGUO? — la pregunta, contestada por la REGLA, no por el texto del aviso.
 * ESPEJO de `backend/services/telefonoE164.esAmbiguoConEspana`. Tres sitios necesitan distinguir
 * «no se puede componer» de «no se compone A PROPOSITO porque tambien se lee como español». Si cada
 * uno lo dedujera buscando un trozo del mensaje, el dia que alguien mejore esa frase empezarian a
 * parar un guardado que tiene que pasar, en silencio.
 */
export function esAmbiguoConEspana(valor, paisIso) {
  const { d, masDelante } = _limpiar(valor)
  if (!d || masDelante || d.startsWith('00')) return false
  const pais = paisDeTelefono(paisIso)
  if (!pais || pais.prefijo === PAIS_DEFECTO) return false
  return RE_ES_COMPLETO.test(d) || desviaUnMovilEspanol(valor)
}

/** El porqué, para enseñárselo a quien lo está escribiendo. `null` si el número vale. */
export function motivoDeclarado(valor, paisIso) {
  const s = String(valor == null ? '' : valor).trim()
  if (!s) return 'no tiene teléfono'
  if (aE164Declarado(s, paisIso)) return null
  const pais = paisDeTelefono(paisIso)
  if (!pais) return motivoNoValido(s, PAIS_DEFECTO, null)
  const { d } = _limpiar(s)
  // Aquí no hay ningún número («(madre)», «ver móvil»): el país elegido no puede contradecir lo que
  // no existe. El porqué entero, con lo que costaba, en el backend (`telefonoEntrada`).
  if (!d) return null
  if (SEPARADORES.test(s)) return 'El campo del teléfono lleva más de un número.'
  if (pais.prefijo !== PAIS_DEFECTO && (RE_ES_COMPLETO.test(d) || desviaUnMovilEspanol(s))) {
    const comoDeberia = sugerenciaDeclarada(s, pais.iso)
    const esp = RE_ES_COMPLETO.test(d) ? '' : ` (el móvil ${String(aE164(s) || '').replace(/^34/, '')})`
    return `Has elegido ${pais.nombre} y este número (${d}) también se lee como español${esp}. `
      + `Escríbelo con el prefijo (${comoDeberia || '+' + pais.prefijo}) o cambia el país a España.`
  }
  const nacional = sinTroncal(pais.iso, d)
  return `Un número de ${pais.nombre} tiene ${cifrasDe(pais.longitudes)} cifras. Has escrito ${nacional.length}.`
}

/** El aviso que NO impide enviar: el número ya trae un prefijo distinto del país elegido. */
export function avisoDeclarado(valor, paisIso) {
  const { d, masDelante } = _limpiar(valor)
  if (!d || !(masDelante || d.startsWith('00'))) return null
  const elegido = paisDeTelefono(paisIso)
  if (!elegido) return null
  const e164 = aE164(valor, PAIS_DEFECTO, paisIso)
  if (!e164 || e164.startsWith(elegido.prefijo)) return null
  const suyo = paisDelNumero(e164)
  const nombre = suyo && !suyo.ambiguo ? `${suyo.nombre}` : 'otro país'
  const pref = suyo && !suyo.ambiguo ? `+${suyo.prefijo}` : `+${e164.slice(0, 2)}`
  return `Este número ya lleva el prefijo ${pref} (${nombre}). Se enviará a ${nombre}, no a ${elegido.nombre}.`
}
